export default __webpack_public_path__ + "static/media/llAdmin.88b301f5.svg";